(() => {
  new Swiper('.js-engagement-slider', {
    slidesPerView: 1,
    spaceBetween: 0,
    centeredSlides: true,
    effect: 'fade',
    watchOverflow: true,
    allowTouchMove: false,
    loopAdditionalSlides: 2,
    preventClicks: false,
    breakpoints: {
      990: {
        spaceBetween: 0
      }
    },
    pagination: {
      el: ".js-engagement__slider-pagination",
      type: "bullets",
      clickable: true
    },
    navigation: {
      nextEl: '.js-engagement__slider-next',
      prevEl: '.js-engagement__slider-prev'
    },
    on: {
      sliderMove: function(e) {
        const slides = qsa('.engagement__item.swiper-slide');
        if(slides) {
          slides.forEach((item) => {
            setTimeout(() => {
              item.style.opacity = '';      
            })
          })
        }
      },
      slideChange: function() {
        const slides = qsa('.engagement__item.swiper-slide');
        if(slides) {
          slides.forEach((item) => {
            setTimeout(() => {
              item.style.opacity = '';      
            }, 200)
          })
        }
      },
    }
  })

  function engageSlides() { 
    const slides = qsa('.engagement__item.swiper-slide');
    if(slides) { 
      slides.forEach((item) => {
        setTimeout(() => {
          item.style.opacity = '';      
        }, 300);
      })
    } else { // if not, then run again the insta function
      setTimeout(() => {
        engageSlides();
      }, 200)
    }
  }
  engageSlides(); // call the insta function
})();